function ParallelTask(tasks, parallelCount = 2) {
  return new Promise((resolve, reject) => {
    if (tasks.length === 0) {
      resolve()
      return
    }
    let nextIndex = 0
    let finishCount = 0
    let resultMap = {}
    function _run () {
      const task = tasks[nextIndex]
      let currentIndex = nextIndex
      nextIndex++
      task().then(res => {
        finishCount++
        resultMap[currentIndex] = res
        if (nextIndex < tasks.length) {
          _run()
        } else if (finishCount === tasks.length) {
          resolve(Object.values(resultMap))
        }
      }).catch(err => {
        reject(err)
        return
      })
    }
    for (var i = 0; i < parallelCount && i < tasks.length; i++) {
      _run()
    }
  }) 
}

export default ParallelTask